import { createSlice } from '@reduxjs/toolkit';

import { IBasic } from '@/interface';

export interface BasicState {
  basic: IBasic;

}

const initialState: BasicState = {
  basic: {
    currTab: 0,
    pageUniqueKey: '',
  },
};

export const basic = createSlice({
  name: 'basic',
  initialState,
  reducers: {
    changeBasicPageUniqueKey(state, action) {
      return {
        ...state,
        basic: { ...state.basic, ...action.payload },
      };
    },
    changeBasic(state, action) {
      return {
        ...state,
        basic: { ...state.basic, ...action.payload },
      };
    },
  },
});

export const { changeBasic, changeBasicPageUniqueKey } = basic.actions;

export default basic.reducer;
